import React from "react";
import { humanize } from "../../utils/alerts";
import "./AlertsSummaryFilter.css";

class AlertsSummaryFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: this.getInitialFilters(true, props.initialFilters),
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      filters: this.getInitialFilters(true, nextProps.initialFilters),
    });
  }

  getInitialFilters = (defaultState, initialFilters) => {
    let filterStates = {};
    Object.keys(this.props.alertCounts).forEach(k => {
      if (!this.props.alertTypeOptions[k]) {
        return;
      }

      let state = defaultState;
      if (initialFilters) {
        state = initialFilters.indexOf(k) >= 0;
      }
      filterStates[k] = state;
    });

    return filterStates;
  };

  handleFilterOnClick = filterType => {
    // From a UX point of view, intuitively clicking a tile when they are all visible means you want to see just that
    // data. So when all tiles are selected, click one disables all other ones. After than clicking tiles simply toggles
    // them on/off until they all become on again.
    // I (Mike) could be totally wrong and it's not intuitive at all but I think it works nicely.
    let nextFilters, nextFiltersActivated;
    if (this.areAllVisible()) {
      nextFilters = this.getInitialFilters(false);
      nextFilters[filterType] = true;
      nextFiltersActivated = true;
    } else {
      nextFilters = {
        ...this.state.filters,
        [filterType]: !this.state.filters[filterType],
      };
      nextFiltersActivated = this.state.filtersActivated;
    }

    this.setState({
      filters: nextFilters,
      filtersActivated: nextFiltersActivated,
    });

    this.updateAlerts(nextFilters);
  };

  showAll = () => {
    const filters = this.getInitialFilters(true);
    this.setState({ filters });
    this.updateAlerts(filters);
  };

  updateAlerts = filters => {
    const filtersEnabled = [];
    let foundDisabledFilter = false;
    for (let filter in filters) {
      if (filters[filter] === true) {
        filtersEnabled.push(filter);
      } else {
        foundDisabledFilter = true;
      }
    }

    // If we didn't find any disabled filters then they must all be selected.
    // In which case we aren't actually filtering so pass null.
    if (!foundDisabledFilter) {
      this.props.fetchAlerts(null);
      return;
    }

    this.props.fetchAlerts(filtersEnabled.join());
  };

  areAllVisible = () => {
    const filters = this.state.filters;
    for (let k in filters) {
      if (!filters[k]) return false;
    }
    return true;
  };

  render() {
    const filters = this.state.filters;
    const allVisible = this.areAllVisible();

    if (this.props.alertCounts["total"] === 0) {
      return null;
    }

    return (
      <div className="alerts-summary-filter-container">
        {Object.keys(this.props.alertCounts).map(k => {
          if (k === "total" || k === "silenced") {
            return <></>;
          }
          let displayOptions = { label: humanize(k), description: "" };
          if (!this.props.alertTypeOptions[k]) {
            return <></>;
          }
          displayOptions = this.props.alertTypeOptions[k];
          return (
            <div
              className={`filter-item ${filters[k] ? "on" : "off"}`}
              onClick={() => this.handleFilterOnClick(k)}
            >
              <div className="count">{this.props.alertCounts[k]}</div>
              <div className="label">{displayOptions.label}</div>
              <div className="description">{displayOptions.description}</div>
            </div>
          );
        })}
        <div className="filter-item total" onClick={allVisible ? () => {} : this.showAll}>
          <div className="count">{this.props.alertCounts["total"]}</div>
          <div className="label">{allVisible ? "Total" : "Show All"}</div>
        </div>
      </div>
    );
  }
}

export default AlertsSummaryFilter;
